import { c as _c } from "react/compiler-runtime";
import { QuestionStatus, questionStatusMd } from 'shared/forecast/questionStatus';
import { ActionIcon, MultiSelect, Popover, Switch, Tooltip, CloseButton } from '@mantine/core';
import { DatePicker, DatePickerProps, DateValue, TimeInput } from '@mantine/dates';
import { useInterval } from '@mantine/hooks';
import { match, P } from 'ts-pattern';
import { DateTime as D } from 'luxon';
import { useState, useEffect } from 'react';
import { QuestionCfg, questionReminderOptions } from 'shared/forecast';
import { compactObj, entries, concat } from 'shared/collection';
import { doSafe, doTo } from 'shared/promise';
import { StyleProps } from 'components';
import { ChildrenProps } from 'shared/ui/uiType';
import { fmtDate } from 'shared/format';
import { LabelForm } from 'shared/ui';
import { HiCalendar } from 'react-icons/hi2';
import { colors } from 'components/theme/theme';
import { DbFormSubset } from 'components/hooks/useDbForm';
import { ChevronIcon } from 'components/icons';
export type DueCfg = QuestionCfg['due']['forecasting' | 'question-review' | 'conditional-generation'];
export type DueKeys = keyof QuestionCfg['due'];
export const DueButton = t0 => {
  const $ = _c(21);
  const {
    status,
    form: t1,
    readonly
  } = t0;
  const {
    values,
    getInputProps,
    setValues
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Intl.DateTimeFormat().resolvedOptions();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const tz = t2.timeZone;
  const [, setSeconds] = useState(0);
  let t3;
  if ($[1] !== setSeconds) {
    t3 = () => setSeconds(_temp);
    $[1] = setSeconds;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const interval = useInterval(t3, 5000);
  let t4;
  if ($[3] !== interval) {
    t4 = () => {
      interval.start();
      return interval.stop;
    };
    $[3] = interval;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== getInputProps) {
    t6 = getInputProps("reminderOptions" as any);
    $[6] = getInputProps;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== getInputProps) {
    t7 = getInputProps("reminderEnabled" as any, {
      type: "checkbox"
    });
    $[8] = getInputProps;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = {
      reminderOptions: t6,
      reminderEnabled: t7
    };
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const props = t8;
  const valuesForecasting = status == "forecasting" ? values as QuestionCfg['due']['forecasting'] : undefined;
  let t9;
  if ($[13] !== getInputProps || $[14] !== props || $[15] !== readonly || $[16] !== setValues || $[17] !== status || $[18] !== values || $[19] !== valuesForecasting) {
    const dateTime = values?.date ? D.fromISO(values.date) : undefined;
    t9 = <div>{readonly ? values?.date ? <DueLabel date={values.date} status={status} /> : <></> : <Popover position="bottom-start" withinPortal={true}><Popover.Target><div className="flex items-center p-1 hover:bg-gray-100 hover:cursor-pointer rounded-md gap-1">{values?.date ? <DueLabel date={values.date} status={status} /> : <HiCalendar size={22} color={colors.gray[3]} />}<ChevronIcon /></div></Popover.Target><Popover.Dropdown><div className="flex flex-col gap-6 items-start"><div className="flex gap-4 items-center"><div className="flex flex-col gap-2 items-start"><LabelForm className="">Due date (in {tz} time)</LabelForm><DatePicker {...doTo(getInputProps("date"), d => ({
                  ...d,
                  value: d.value ? D.fromISO(d.value).toISODate() : null,
                  onChange: s_0 => {
                    const date = s_0 == null ? null : D.fromISO(s_0);
                    const dateWithTime = date?.set(dateTime ? {
                      hour: dateTime.hour,
                      minute: dateTime.minute
                    } : {
                      hour: 23,
                      minute: 59
                    });
                    d.onChange(dateWithTime?.toISO());
                  }
                }))} weekendDays={[]} size="md" renderDay={renderDay} defaultDate={D.now().toISODate()} allowDeselect={true} /><div><TimeInput size="md" variant="filled" value={dateTime ? dateTime.toLocal().toFormat("HH:mm") : ""} label="Time" disabled={!dateTime} onChange={v => {
                    if (!dateTime) {
                      return;
                    }
                    const {
                      hour,
                      minute
                    } = D.fromISO(v.target.value).toObject();
                    const date_0 = dateTime.toLocal().set({
                      hour,
                      minute
                    }).toUTC().toISO();
                    setValues({
                      date: date_0
                    });
                  }} /></div></div>{dateTime && <ActionIcon onClick={() => setValues({
                date: undefined
              })}><Tooltip label="Clear due date"><CloseButton size="lg" /></Tooltip></ActionIcon>}</div>{valuesForecasting && <div className="space-y-2"><Switch {...{
                ...props.reminderEnabled,
                onChange: e => {
                  const checked = e.target.checked;
                  setValues(compactObj({
                    reminderEnabled: checked == valuesForecasting.reminderEnabled ? undefined : checked,
                    reminderOptions: checked && !valuesForecasting.reminderEnabled ? ["PT-24H", "PT-1H"] : undefined
                  }));
                }
              }} size="md" label="remind participants with incomplete forecasts" />{values && "reminderEnabled" in values && values.reminderEnabled && <MultiSelect data={entries(questionReminderOptions).map(_temp2)} size="md" {...props.reminderOptions} />}</div>}</div></Popover.Dropdown></Popover>}</div>;
    $[13] = getInputProps;
    $[14] = props;
    $[15] = readonly;
    $[16] = setValues;
    $[17] = status;
    $[18] = values;
    $[19] = valuesForecasting;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
const renderDay: DatePickerProps['renderDay'] = date => {
  const now = D.now();
  const d = D.fromISO(date);
  const isToday = now.hasSame(d, 'day');
  const isPast = d < now;
  return <div className='font-semibold' style={{
    color: isToday ? 'var(--mantine-primary-color-filled)' : isPast ? 'var(--mantine-color-orange-5)' : undefined
  }}>
      {d.day}
    </div>;
};
export const DueLabel = t0 => {
  const $ = _c(17);
  const {
    date: dateRaw,
    color: colorRaw,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== colorRaw || $[1] !== dateRaw) {
    const date = doSafe(dateRaw, _temp3);
    const hrs = date ? date.diffNow().as("hours") : undefined;
    t1 = colorRaw ?? match(hrs).with(P.number.negative(), _temp4).with(P.number.lte(24), _temp5).otherwise(_temp6);
    $[0] = colorRaw;
    $[1] = dateRaw;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const color = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-gray-500">due </span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== color) {
    t3 = {
      color
    };
    $[4] = color;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dateRaw) {
    t4 = fmtDate(dateRaw, {
      showTime: true,
      minUnit: "minute"
    });
    $[6] = dateRaw;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <span className="font-semibold" style={t3}>{t4}</span>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== t5) {
    t6 = <span>{t5}{children}</span>;
    $[11] = children;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== className || $[15] !== t6) {
    t7 = <span className={className}>{t2}{t6}</span>;
    $[14] = className;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
function _temp(s) {
  return s + 1;
}
function _temp2(t0) {
  const [value, t1] = t0;
  const {
    label
  } = t1;
  return {
    value,
    label
  };
}
function _temp3(d) {
  return D.fromISO(d);
}
function _temp4() {
  return colors.red[5];
}
function _temp5() {
  return colors.amber[5];
}
function _temp6() {
  return colors.gray[6];
}